import { calculateBidderPremium } from 'helpers/auctions';
import { format_money } from 'helpers/number';
import Link from 'components/Link';


const ListItems = ({ type_id, cleanoutTime }) => {
    const isLien = type_id == 1;
    const isNonLien = type_id == 2;
    const isCharity = type_id == 3;

    return (
        <>
            <li>Units that are not paid for nor vacated within the {cleanoutTime} hours cleanout time will result in my
                account suspension.
            </li>
            {isCharity &&
                <li>I understand that 100% of the balance will be charged to my credit card on file if I win a charity
                    auction.</li>}
            {isLien &&
                <li>I understand the defaulted tenant has the legal right to cure the account thus canceling the auction
                    up until the cash payment is received from the winning bidder unless otherwise stated in the state's
                    lien laws or by the storage facility.</li>}
            <li>I acknowledge that all auction unit(s) are subject to cancellation by
                the {isNonLien ? 'seller' : 'storage facility'}.
            </li>
            <li>I accept that if I am the winning bidder and do not submit payment within 24 hours of the auction close
                time, the unit can be offered to alternate bidders.
            </li>
            <li>I am liable for my winning bids and associated premiums, taxes, and fees regardless of whether I claim
                the property in the auction unit(s).
            </li>
            <li>If I win, I am responsible for a minimum buyer premium of $10.</li>
            <li>I understand that cleanout time, deposits, and taxes may vary by facility.</li>
            <li>I have reviewed the Additional Information and Auction Rules on this auction page.</li>
            <li>By registering and bidding on StorageTreasures.com, I agree not to dispute any credit card charges
                processed through this site and waive my right to pursue litigation against StorageTreasures.com.
            </li>
            <li>By clicking the button <strong>Yes, I agree, bid now</strong>, I accept the fact that I am entering into
                a legal binding contract. The auction rules as highlighted from the <Link target="_blank" to="/terms">Terms
                    of
                    Use</Link> apply.
            </li>
        </>
    );
};

const ConfirmBid = ({ bidConfirmed, auction, onClickHandler, isPlacingBidModal, minimumBid, premiumPercentage }) => {
    return (<>
        <div>
            <ul className="txt-left">
                <li>I agree to bid ${format_money(bidConfirmed)}.</li>
                {!auction?.user?.is_high_bidder && Number(bidConfirmed) > Number(auction?.user?.max_bid?.amount ?? 0) &&
                    <li>I agree my bidder premium on this bid is
                        ${format_money(calculateBidderPremium(bidConfirmed, premiumPercentage, minimumBid))}.</li>}
                <li>I agree to the terms for placing max bids, acknowledging adjusted premiums.</li>
            </ul>
            <ul className="txt-left">
                <ListItems type_id={auction?.type_id} cleanoutTime={auction.cleanout_time}/>
            </ul>
        </div>
        <div className="modal-footer text-center">
            <button
                className="btn btn-blue btn-regular btn-block modal-btn-block"
                onClick={onClickHandler}
                disabled={isPlacingBidModal}
            >
                {isPlacingBidModal ? <i className="fa fa-spin fa-spinner"/> : null}
                {' '}
                Yes, I agree, bid now
            </button>
        </div>
    </>);
};

export { ConfirmBid };
